import '../styles/shifterBox.less';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';
import { render } from 'mustache';
import view from './shifterBoxView';

var isIe7OrIe8 = common.isIe7() || common.isIe8(),
    isTouchDevice = common.isTouchDevice();

function getInputData($sb) {
    var inputDataId = $sb.data('input'),
        inputDataReference = $sb.data('input-reference'),
        inputData,
        inputJson,
        $inputScript;
    if (inputDataReference) {
        inputData = common.resolveReference(inputDataReference);
    } else {
        $inputScript = $('#' + inputDataId);
        inputJson = $inputScript.html();
        inputData = $.parseJSON(inputJson);
    }
    return inputData;
}

function transformNode(inputNode, stateNode, idPrefix) {
    if (inputNode) {
        stateNode.title = inputNode.title ? $.trim(inputNode.title) : '';
        if (inputNode.items) {
            $.each(inputNode.items, function (i, el) {
                stateNode.items.push({
                    id: idPrefix + $.trim(el.id),
                    name: $.trim(el.name)
                });
            });
        }
    }
}

/**
 * Create the inner state from the input data. It does some validation and data transformation.
 */
function transformToState(inputData) {
    var state,
        idPrefix;

    state = {
        left: {
            items: [],
            title: ''
        },
        right: {
            items: [],
            title: ''
        },
        autoSort: false
    };

    if (inputData) {
        idPrefix = $.trim(inputData.idPrefix);

        transformNode(inputData.left, state.left, idPrefix);
        transformNode(inputData.right, state.right, idPrefix);

        state.autoSort = !!inputData.autoSort;
    }

    sortList(state.left.items, state.autoSort);
    sortList(state.right.items, state.autoSort);

    return state;
}

function getInternalState($sb) {
    return $sb.data('state');
}

function refreshItems($sb) {
    var state = getInternalState($sb),
        $leftItems = $sb.find('.uwr-shifter-box-panel-left .uwr-shifter-box-items'),
        $rightItems = $sb.find('.uwr-shifter-box-panel-right .uwr-shifter-box-items'),
        $formElements = $sb.find('.uwr-shifter-box-form-elements'),
        itemsTemplate,
        leftItemsHtml,
        rightItemsHtml,
        formElementsHtml;

    itemsTemplate = isTouchDevice ? view.itemListTablet : view.itemListDesktop;

    leftItemsHtml = render(itemsTemplate, state.left);
    $leftItems.html(leftItemsHtml);

    rightItemsHtml = render(itemsTemplate, state.right);
    $rightItems.html(rightItemsHtml);

    formElementsHtml = render(view.itemListFormElements, $.extend({selected: false}, state.left));
    $formElements.html(formElementsHtml);
    formElementsHtml = render(view.itemListFormElements, $.extend({selected: true}, state.right));
    $formElements.append(formElementsHtml);
}

function setButtonDisabled($btn, bool) {
    $btn.prop('disabled', bool);
}

function hasSelected($inputs) {
    var hasSelectedItem = false,
        prop = isTouchDevice ? 'checked' : 'selected',
        i;
    for (i = 0; i < $inputs.length; i++) {
        if ($($inputs[i]).prop(prop)) {
            hasSelectedItem = true;
            break;
        }
    }
    return hasSelectedItem;
}

function getInputSelector(onlySelected) {
    var inputSelector;
    if (isTouchDevice) {
        inputSelector = 'input' + (onlySelected ? ':checked' : '');
    } else {
        inputSelector = 'option' + (onlySelected ? ':selected' : '');
    }
    return inputSelector;
}

function refreshButtons($sb) {
    var state = getInternalState($sb),
        $rightShiftBtn = $sb.find('.uwr-shifter-box-button-right-shift'),
        $leftShiftBtn = $sb.find('.uwr-shifter-box-button-left-shift'),
        $rightShiftAllBtn = $sb.find('.uwr-shifter-box-button-right-shift-all'),
        $leftShiftAllBtn = $sb.find('.uwr-shifter-box-button-left-shift-all'),
        inputSelector = getInputSelector(),
        $leftInputs = $sb.find('.uwr-shifter-box-panel-left ' + inputSelector),
        $rightInputs = $sb.find('.uwr-shifter-box-panel-right ' + inputSelector);

    setButtonDisabled($rightShiftBtn, !hasSelected($leftInputs));
    setButtonDisabled($leftShiftBtn, !hasSelected($rightInputs));
    setButtonDisabled($rightShiftAllBtn, state.left.items.length === 0);
    setButtonDisabled($leftShiftAllBtn, state.right.items.length === 0);
}

function addItemClickHandler($sb) {
    function tabletIe7Ie8Handler(event, $label) {
        event.preventDefault();
        event.stopPropagation();
        var $input = $label.parents('li').find('input');
        if ($input.prop('checked') === undefined) {
            $input.prop('checked', 'checked');
            $label.addClass('uwr-shifter-box-item-checked');
        } else {
            $input.removeProp('checked');
            $label.removeClass('uwr-shifter-box-item-checked');
        }
    }

    function refresh() {
        setTimeout(function () {
            refreshButtons($sb);
        }, 100);
    }

    if (isTouchDevice) {
        // Workaround for IE7/IE8 to highlight the checked elements (Tablets in IE8 mode)
        $sb.on('click', $sb.find('li label'), function (event) {
            if (isIe7OrIe8) {
                tabletIe7Ie8Handler(event, $(this));
            }
            refresh();
        });
    } else {
        var $shifterBoxItems = $('.uwr-shifter-box-items', $sb);
        $shifterBoxItems.on('mouseup', function () {
            refresh();
        });
    }
}

function moveObject(id, moveFromList, moveToList) {
    var i,
        item;
    for (i = 0; i < moveFromList.length; i++) {
        item = moveFromList[i];
        if (item.id === id) {
            moveFromList.splice(i, 1);
            moveToList.push(item);
            break;
        }
    }
}

function sortFunction(a, b) {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
}

function sortList(list, autoSort) {
    if (autoSort) {
        list.sort(sortFunction);
    }
}

function addButtonsClickHandler($sb) {
    var $buttons = $sb.find('.uwr-shifter-box-buttons .uwr-shifter-box-button');

    $buttons.on('click', function (event) {
        event.preventDefault();

        var $btn = $(this),
            state = getInternalState($sb),
            btnClass = $btn.prop('class'),
            isRightShiftBtn = btnClass.indexOf('-right-shift') > -1,
            isAllBtn = $btn.prop('class').indexOf('-all') > -1,
            moveFromPanelClass = isRightShiftBtn ? 'uwr-shifter-box-panel-left' : 'uwr-shifter-box-panel-right',
            inputSelector = getInputSelector(!isAllBtn),
            $selectedItems,
            moveFromList = isRightShiftBtn ? state.left.items : state.right.items,
            moveToList = isRightShiftBtn ? state.right.items : state.left.items;

        $selectedItems = $sb.find('.' + moveFromPanelClass + ' ' + inputSelector);
        $selectedItems.each(function (i, elem) {
            var id = $(elem).prop('id');
            moveObject(id, moveFromList, moveToList);
        });

        sortList(moveToList, state.autoSort);

        refreshItems($sb);
        refreshButtons($sb);
    });
}

function updateSizes($sb, prefix, elementExtras) {
    var heightAttributeName = prefix + 'height',
        widthAttributeName = prefix + 'width',
        fixHeight,
        fixWidth,
        panelHeight,
        panelWidth,
        requiredHeight = $sb.css(heightAttributeName),
        requiredWidth = $sb.css(widthAttributeName);

    if (requiredHeight || requiredWidth) {
        // total of fixed width paddings between buttons and panels and around panels
        fixWidth = elementExtras.panels.left.width + elementExtras.items.left.width + elementExtras.buttons.width
                + elementExtras.items.right.width + elementExtras.panels.right.width;
        fixHeight = Math.max(elementExtras.panels.left.height, elementExtras.panels.right.height)
                + Math.max(elementExtras.labels.left.height, elementExtras.labels.right.height)
                + Math.max(elementExtras.items.left.height, elementExtras.items.right.height);

        panelWidth = Math.floor((requiredWidth.replace('px', '') - fixWidth) / 2);
        panelHeight = Math.max(requiredHeight.replace('px', '') - fixHeight, elementExtras.buttons.height);

        $sb.find('.uwr-shifter-box-items').css(heightAttributeName, panelHeight + 'px');
        $sb.find('.uwr-shifter-box-items').css(widthAttributeName, panelWidth + 'px');
    }
}

/**
 * Should be refactored later because values in this function should be kept in sync with CSS changes which
 * is very error prone. Exact values should be calculated instead.
 */
function createElementExtrasObject() {
    var elementExtras = {};
    elementExtras.buttons = {width: 35, height: 120};
    elementExtras.panels = {};
    elementExtras.panels.left = {width: 0, height: 0};
    elementExtras.panels.right = {width: 0, height: 0};
    elementExtras.labels = {};
    elementExtras.labels.left = {width: 0, height: 20};
    elementExtras.labels.right = {width: 0, height: 20};
    elementExtras.items = {};
    elementExtras.items.left = {width: 2, height: 2};
    elementExtras.items.right = {width: 2, height: 2};
    return elementExtras;
}

function setSizes($sb) {
    var elementExtras = createElementExtrasObject();
    updateSizes($sb, '', elementExtras);
    updateSizes($sb, 'min-', elementExtras);
    updateSizes($sb, 'max-', elementExtras);
}

function initSingle($sb) {
    var inputData = getInputData($sb),
        state = transformToState(inputData),
        sbHtml;

    if (isTouchDevice) {
        $sb.addClass('uwr-shifter-box-tablet');
    }

    sbHtml = render(view.mainMarkup, {
        titleLeft: state.left.title,
        titleRight: state.right.title
    });
    $sb.html(sbHtml);

    $sb.data('state', state);
    refreshItems($sb);
    refreshButtons($sb);

    addItemClickHandler($sb);
    addButtonsClickHandler($sb);
    setSizes($sb);
}

function transformStateItemsToPublicItems(stateItems) {
    var result = [],
        i,
        item;
    if (stateItems.length > 0) {
        for (i = 0; i < stateItems.length; i++) {
            item = stateItems[i];
            result.push({id: item.id, name: item.name});
        }
    }
    return result;
}

/**
 * Get the state of the Shifter Box.
 *
 * @param {string} The CSS selector of the Shifter Box div of which state is needed. It is recommended to
 *                 set id attribute of the Shifter Box HTML div.
 * @param {function} The callback function, which handles the state of the given Shifter Box. It has
 *                   one parameter: state. This state object is the JSON representation of the current
 *                   state of the Shifter Box.
 */
export function getState(selector, callback) {
    var state = getInternalState($(selector)),
        publicState = {
            left: transformStateItemsToPublicItems(state.left.items),
            right: transformStateItemsToPublicItems(state.right.items)
        };
    if ($.type(callback) === 'function') {
        callback(publicState);
    }
}

/**
 * Initializes all shifter boxes on the page. Should be called by client apps only after injecting
 * shifter boxes dynamically.
 *
 * init() is an asynchronous call, so if some logic needs to be added once init() is finished, a
 * callback function can be passed in as a parameter.
 *
 * @param callback A Javascript function object that will be called at the end of the init() call.
 */
export function init(callback) {
    var $sbs = $('.uwr-shifter-box');
    $.each($sbs, function (i, el) {
        var $sb = $(el);
        initSingle($sb);
    });
    common.invoke(callback);
}



//////////////////
// WEBPACK FOOTER
// ./widgets/ShifterBox/js/shifterBox.js
// module id = 39
// module chunks = main